import { useGetRetailerDepartmentsLazyQuery } from 'domains/merchandising/api'
// Aisle and Department type likely to change when graphql type is created
export type Aisle = {
  name: string
  id: string
}

export type Department = {
  name: string
  id: string
  aisles: Aisle[]
}

export const useGetDepartmentsLazy = () => {
  const [getDepartments, { loading, error, data }] = useGetRetailerDepartmentsLazyQuery()

  const departments = data?.retailer?.departments ?? []

  return { getDepartments, loading, error, departments }
}
